import * as React from "react";
import { JobProps } from "../../../types";
import { profitAnalysisApi } from "../api/profitAnalysisApi";

export function useJobs(): {
  jobs: JobProps[];
  loading: boolean;
  reload: () => void;
} {
  const [jobs, setJobs] = React.useState<JobProps[]>([]);
  const [loading, setLoading] = React.useState(false);

  const reload = React.useCallback(() => {
    setLoading(true);
    profitAnalysisApi
      .listJobs()
      .then((res) => {
        if (res.data && Array.isArray(res.data)) {
          setJobs(res.data);
        } else {
          throw new Error("Failed to fetch jobs");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  React.useEffect(() => {
    reload();
  }, [reload]);

  return { jobs, loading, reload };
}
